import * as React from 'react';
import { SVGProps } from 'react';
const SvgArrowUp = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.70697 15.0209L12 10.7279L16.293 15.0209L17.707 14.6069L12 8.8999L6.29297 14.6069L7.70697 15.0209Z"
      fill="current"
    />
  </svg>
);
export default SvgArrowUp;
